import * as React from 'react';
import { Field } from 'formik';
import Input from '~/common/controls/Input';
import Button from '~/common/elements/mobile/Button';
import { buttonSize, buttonStyle } from '~/common/elements/mobile/consts';

export class sendToName {
  static MAIL = 'to-mail';
  static SMS = 'to-sms';
}

const SaleFormEmailOrSms = (props) => {
  const { sendTo, handleSends, options, isErrEmail, isErrPhone } = props;

  switch (sendTo) {
    case sendToName.MAIL:
      return (
        <div className="ol--pop">
          <div className="m__head">
            <div className="m__head__left">
              <Button
                actionKey="cancel-send"
                buttonStyle={buttonStyle.OL_CLOSE}
                onClick={(actionKey) => handleSends(actionKey)}
              >
                <span className="i i-arw-l" />
              </Button>
            </div>
            <div className="m__head__cent">
              <div className="m__head__titl">Email Receipt</div>
            </div>
            <div className="m__head__right"></div>
          </div>

          <div className="ol--pop__content">
            <div className="m__body__info">Enter the emaill address where you want the receipt to be sent.</div>
            <Field
              name="email"
              placeholder="Enter email address"
              label="Email"
              component={Input}
              className="input input--sm input--withdrop"
              isSearchable={false}
            />
          </div>
          
          <div className="ol--pop__foot">
            < Button
              title={isErrEmail ? 'Enter a Valid Email' : 'Send Email'}
              actionKey="send-to-email"
              buttonStyle={!isErrEmail ? buttonStyle.PRIM : buttonStyle.LARY}
              buttonSize={buttonSize.LG}
              onClick={!isErrEmail ? (actionKey) => handleSends(actionKey, options) : () => {}}
            />
          </div>
        </div>
      );

    case sendToName.SMS:
      return (
        <div className="ol--pop">
          <div className="m__head">
            <div className="m__head__left">
              <Button
                actionKey="cancel-send"
                buttonStyle={buttonStyle.OL_CLOSE}
                onClick={(actionKey) => handleSends(actionKey)}
              >
                <span className="i i-arw-l" />
              </Button>
            </div>
            <div className="m__head__cent">
              <div className="m__head__titl">SMS Receipt</div>
            </div>
            <div className="m__head__right"></div>
          </div>
          <div className="ol--pop__content">
            <div className="m__body__info">Enter the phone number where you want the receipt to be sent.</div>
            <Field
              name="phone"
              placeholder="Enter phone number"
              label="Phone"
              component={Input}
              className="input input--sm"
              isSearchable={false}
            />
          </div>
          <div className="ol--pop__foot">
            < Button
              title={isErrPhone ? 'Enter a Valid Phone' : 'Send Text'}
              actionKey="send-to-sms"
              buttonStyle={!isErrPhone ? buttonStyle.SECN : buttonStyle.LARY}
              buttonSize={buttonSize.LG}
              onClick={!isErrPhone ? (actionKey) => handleSends(actionKey, options) : () => {}}
            />
          </div>
        </div>
      );

    default:
      return null;
  }
};

export default SaleFormEmailOrSms;
